import React, { useEffect } from 'react';
import { t } from '@lingui/macro';
import { FaSearchMinus } from 'react-icons/fa';

import MouseZoomIcon from '../Icons/MouseZoomIcon';
import { useAccessibilityContext } from '../Providers/AccessibilityProvider/AccessibilityContext';
import { AccessibilityOption } from './AccessibilityButton';

const IncreaseCursor = () => {
  const { isCursorBig, setIsCursorBig } = useAccessibilityContext();

  useEffect(() => {
    if (isCursorBig) {
      increaseCursor();
    } else {
      resetCursor();
    }
  }, [isCursorBig]);

  function toggleCursor() {
    if (setIsCursorBig) {
      setIsCursorBig(!isCursorBig);
    }
  }

  function increaseCursor() {
    document.querySelector('body')?.classList.add('custom_cursor_hover');
  }

  function resetCursor() {
    document.querySelector('body')?.classList.remove('custom_cursor_hover');
  }

  return (
    <AccessibilityOption
      name={'Aumentar cursor'}
      icon={<MouseZoomIcon className="h-3 w-3 fill-white" />}
      onClick={() => toggleCursor()}
    />
  );
};

export default IncreaseCursor;
